/**
 * Events constants for player
 * @typedef {{
 * play: string,
 * waiting: string,
 * positionChanged: string,
 * mediaEnded: string,
 * buffer: string,
 * seeked: string,
 * error: string
 * }} StreamEvents
 */
const streamEvents = {
  buffer: 'buffer',
  positionChanged: 'positionChanged',
  waiting: 'waiting',
  play: 'play',
  error: 'error',
  mediaEnded: 'mediaEnded',
  seeked: 'seeked',
  // meta will be deprecated eventually when we replace the music-metadata dependency and patch the
  // abstraction leak of propagating this metadata to the app layer. The data handled by this event
  // should be folded into the new `metadata` event below.
  meta: 'meta',
  metadata: 'metadata',
  playerSelected: 'playerSelected',
};

export default streamEvents;
